module.exports = __webpack_public_path__ + "static/media/4.432bd4e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quote_to_share/4.png
// module id = 276
// module chunks = 0